/*
    Resolves the OrganizationApp a guarded route refers to.

    Order of preference:
      1. `:appId` from the route - the route already names the exact installation,
         so nothing else may override it (an unknown id stays unresolved).
      2. The SKU matcher - works for parent/layout routes, which in React Router v6
         cannot see their children's `:appId`.
      3. The legacy display name - only reached when the SKU lookup finds nothing
         (e.g. an OrganizationApp pointing at a marketplace app that no longer exists).
 */
export var resolvePermittedApp = function (params) {
    var organizationApps = params.organizationApps, marketplaceApps = params.marketplaceApps, pathname = params.pathname, appId = params.appId, matcher = params.matcher, legacyName = params.legacyName;
    if (appId) {
        return organizationApps.find(function (orgApp) { return orgApp.id === appId; });
    }
    if (matcher) {
        var matchingAppIds_1 = new Set(marketplaceApps
            .filter(function (app) { return (app.sku === matcher.sku
            && (!matcher.specialization || app.specialization === matcher.specialization)); })
            .map(function (app) { return app.id; }));
        var candidates = organizationApps.filter(function (orgApp) { return (!!orgApp.appId && matchingAppIds_1.has(orgApp.appId)); });
        if (candidates.length === 1) {
            return candidates[0];
        }
        if (candidates.length > 1) {
            /*
                Several installations of the same app (e.g. two restaurants). The URL of a
                child route still carries the concrete id, so prefer the one it points at.
            */
            var segments_1 = pathname.split("/").filter(Boolean);
            return candidates.find(function (orgApp) { return !!orgApp.id && segments_1.includes(orgApp.id); }) || candidates[0];
        }
    }
    if (legacyName) {
        return organizationApps.find(function (orgApp) { return orgApp.name === legacyName; });
    }
    return undefined;
};
